import { useEffect, useState } from 'react';
import type { CSSProperties } from 'react';

import { useReducedMotion } from '#hooks/useReducedMotion';

import { claseDestellos } from './gaviCss';

/** Hacia dónde sale cada rombo (px): los cuatro puntos cardinales y dos más. */
export const RUMBOS_DESTELLO: readonly (readonly [number, number])[] = [
  [0, -34],
  [46, 0],
  [0, 34],
  [-46, 0],
  [32, -24],
  [-32, 24],
];

/** Lo que dura la ráfaga antes de quitarse (la animación es de 0,9 s). */
const DURACION = 1000;

type DestellosProps = {
  /**
   * Cada valor nuevo distinto de 0 lanza una ráfaga (p. ej. un contador que
   * sube al llegar a 0 «listos para asignar»). 0 = nada.
   */
  disparo: number;
  style?: CSSProperties;
};

/**
 * Destellos al llegar a 0: rombos en acento que salen del centro del padre
 * (que debe tener `position: relative`). Con «reducir movimiento», nada.
 */
export function Destellos({ disparo, style }: DestellosProps) {
  const quieto = useReducedMotion();
  const [acabado, setAcabado] = useState<number | null>(null);

  useEffect(() => {
    if (!disparo) {
      return;
    }
    const id = window.setTimeout(() => setAcabado(disparo), DURACION);
    return () => window.clearTimeout(id);
  }, [disparo]);

  if (quieto || !disparo || acabado === disparo) {
    return null;
  }
  return (
    <span
      key={disparo}
      className={claseDestellos}
      data-testid="destellos"
      aria-hidden
      style={style}
    >
      {RUMBOS_DESTELLO.map(([dx, dy]) => (
        <i
          key={`${dx},${dy}`}
          style={{ '--dx': `${dx}px`, '--dy': `${dy}px` } as CSSProperties}
        />
      ))}
    </span>
  );
}
